import ContentBlock from '../ContentBlock';
import ImageLink from '../ImageLink';

const defaultProps = {
  ...ContentBlock.DefaultProps,
  ...ImageLink.DefaultProps,
};

export default defaultProps;
